import {RootState} from "@/reducers/store";
import {FC,useEffect,useReducer} from "react";
import {useSelector} from "react-redux";

interface IProps {
    type: "primary" | "secondary" | "tertiary" | "quaternary";
    stateProp: "enabled" | "pressed" | "focus" | "hover" | "disabled";
    icon: boolean;
    text: string;
    handleClick: ()=> void;
    suffixIcon?: React.ReactNode;
}

const ACTIONS = {
    MOUSE_ENTER: "mouse_enter",
    MOUSE_LEAVE: "mouse_leave",
    DATA_ENTERED: "data_entred",
    DATA_NOT_AVAILABLE: 'data_not_available',
    CLICK: "click",
};

function reducer(state: any, action: string) {
    switch (action) {
        case ACTIONS.MOUSE_ENTER:
            return { ...state, state: "hover" };
        case ACTIONS.MOUSE_LEAVE:
        case ACTIONS.DATA_ENTERED:
            return { ...state, state: "enabled" };
        case ACTIONS.DATA_NOT_AVAILABLE:
                return { ...state, state: "disabled" };
        case ACTIONS.CLICK:
            return { ...state, state: "pressed" };
        default:
            return state;
    }
}

const Button: FC<IProps> = ({ type, stateProp, icon, text, handleClick, suffixIcon }: IProps): JSX.Element => {
    const { currentQuestion } = useSelector((state:RootState) => state.patientSurvey);
    const form = useSelector((state:RootState) => state.form);
    const [state, dispatch] = useReducer(reducer, {
        type: type || "primary",
        state: stateProp || "enabled",
        icon: icon || false,
    });

    useEffect(() => {
        if (stateProp === 'disabled') {
            dispatch(ACTIONS.DATA_NOT_AVAILABLE);
        } else {
            dispatch(ACTIONS.DATA_ENTERED);
        }
    }, [stateProp]);

    useEffect(() => {
        // Survey form sync must not override an explicit disabled button (e.g. Move to POA modal).
        if (stateProp === 'disabled') {
            return
        }
        if (
            state.state !== 'hover' &&
            state.state !== 'enabled' &&
            currentQuestion &&
            currentQuestion.name &&
            form[currentQuestion.name] &&
            form[currentQuestion.name].value
        ) {
            dispatch(ACTIONS.DATA_ENTERED)
        }
        if (
            state.state === 'enabled' &&
            currentQuestion &&
            currentQuestion.name &&
            form[currentQuestion.name] &&
            !form[currentQuestion.name].value
        ) {
            dispatch(ACTIONS.DATA_NOT_AVAILABLE)
        }
    }, [state, currentQuestion, form, stateProp])

    return (
        <div
            role="button"
            className={`save-button ${state.state} ${state.type}`}
            onMouseEnter={() => {
                if(state.state !== 'disabled'){
                    dispatch(ACTIONS.MOUSE_ENTER)
                } 
            }}
            onMouseLeave={() => { 
                if (state.state !== 'disabled'){
                    dispatch(ACTIONS.MOUSE_LEAVE)
                } 
            }}
            onClick={() => {
                if (state.state === 'disabled') return;
                dispatch(ACTIONS.CLICK);
                handleClick()
            }}
        >
            <div className={`outer state-${state.state} type-${state.type} icon-${state.icon}`}>
                    <div className="inner">
                        <div className="next">
                            {!state.icon ? text : <div className="text-wrapper">{text}</div>}
                            {suffixIcon && <span className="suffix-icon flex items-center">{suffixIcon}</span>}
                        </div>
                    </div>
            </div>
        </div>
    );
};

export default Button;
